<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle"
                  data-toggle="collapse"
                  data-target="#navigation-example-2"
                  @click="toggleNavbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link class="navbar-brand" to="/admin">PPEs Locator</router-link>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <router-link to="/register" tag="li">
              <a>Sign Up</a>
            </router-link>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color=""
           data-image="static/img/background/background-2.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <form method="#" action="#">
                  <div class="card" data-background="color" data-color="blue">
                    <div class="card-header">
                      <h3 class="card-title">Reset Password</h3>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>Username</label>
                        <input
                          type="text"
                          name="username"
                          v-model="model.username"
                          v-validate="modelValidations.username"
                          placeholder="Username"
                          class="form-control input-no-border">
                        <small class="text-danger" v-show="username.invalid">
                          {{ getError('username') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <label>Verification Code</label>
                        <input
                          type="text"
                          name="verfication_code"
                          v-model="model.verfication_code"
                          v-validate="modelValidations.verfication_code"
                          placeholder="Verification Code"
                          class="form-control input-no-border">
                        <small class="text-danger" v-show="username.verfication_code">
                          {{ getError('verfication_code') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <label>Password</label>
                        <input
                          type="password"
                          name="password"
                          v-model="model.password"
                          v-validate="modelValidations.password"
                          placeholder="Password"
                          class="form-control input-no-border">
                        <small class="text-danger" v-show="password.invalid">
                          {{ getError('password') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <label>Confirm Password</label>
                        <input
                          type="password"
                          name="password_confirm"
                          v-model="model.password_confirm"
                          v-validate="modelValidations.password_confirm"
                          placeholder="Confirm Password"
                          class="form-control input-no-border">
                        <small class="text-danger" v-show="password_confirm.invalid">
                          {{ getError('password_confirm') }}
                        </small>
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <button type="submit" v-if="!loading" @click.prevent="confirmPasswordReset()" class="btn btn-fill btn-wd ">Submit</button>
                      <button type="button" v-if="loading" class="btn btn-wd" disabled="disabled">
                        <span class="btn-label">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </span>
                        Submit
                      </button>
                      <!--div class="forgot">
                        <router-link to="/register">
                          Forgot your password?
                        </router-link>
                      </div-->
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              Copyright &copy; 2020 Interdisciplinary Humanistic Technologies All rights reserved.
            </div>
          </div>
        </footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Sign Up</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'

  export default {
    computed: {
      ...mapFields(['username', 'verfication_code', 'password', 'password_confirm'])
    },
    data () {
      return {
        model: {
          username: '',
          verfication_code: '',
          password: '',
          password_confirm: ''
        },
        modelValidations: {
          username: {
            required: true
          },
          verfication_code: {
            required: true
          },
          password: {
            required: true,
            confirmed: 'password_confirm'
          },
          password_confirm: {
            required: true,
            confirmed: 'password'
          }
        },
        loading: false
      }
    },
    methods: {
      confirmPasswordReset () {
        this.loading = true
        this.$cognitoAuth.confirmPassword(this.model.username.toLowerCase(), this.model.verfication_code, this.model.password, (err, result) => {
          if (err) {
            this.error = err
            console.error(err)
            swal({
              title: 'Error',
              text: err.message,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
            this.loading = false
          } else {
            swal({
              title: `Password Changed`,
              text: 'You will be directed back to the login page.',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'success'
            }).then(() => {
              this.$router.replace(this.$route.query.redirect || '/login?username=' + this.model.username)
            })
          }
        })
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeDestroy () {
      this.closeMenu()
    },
    mounted: function () {
      this.$nextTick(function () {
        if (this.$route.query.username) {
          this.model.username = this.$route.query.username
        }
      })
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/ConfirmPassword.vue